import { StateSchema } from 'app/config/storeConfig/types';
import { LoginModalMode } from '../types';

export const getModalMode = (state: StateSchema): LoginModalMode => state.logInModal.mode;
